<template>
  <div>
    <b-navbar toggleable class="navbar">
      <b-link v-if="$route.name != 'home'" @click="goBack">
        <template>
          <i class="fas fa-arrow-circle-left navbar-text-color"></i>
        </template>
      </b-link>
      <b-link
        class="navbar-brand header-item header-item-full justify-content-lg-start"
      >
        <img
          class="navbar-brand-full"
          height="40"
          alt="logo"
          src="../assets/logo.png"
        />
        <div class="mx-auto">
          <b-nav class="d-none d-md-block">
            <tenant-dropdown />
          </b-nav>
        </div>
      </b-link>
      <div class="d-md-down-none navbar-text-color ml-auto header-item">
        <u>{{ currentUsername }}</u>
      </div>
      <b-navbar-nav
        class="d-md-down-none"
        data-cy="logout"
        name="logout"
        @click="logout"
      >
        <i class="fas fa-sign-out-alt navbar-text-color"></i>
      </b-navbar-nav>
      <div class="break"></div>
      <b-nav class="mx-auto">
        <tenant-dropdown class="d-block d-md-none" />
      </b-nav>
    </b-navbar>
    <SideBar />
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SideBar from '../components/SideBar';
import TenantDropdown from '../components/TenantDropdown';

export default {
  name: 'DefaultContainer',
  components: {
    SideBar,
    TenantDropdown
  },
  computed: {
    ...mapGetters('auth', ['currentUsername', 'currentTenant'])
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/LOG_OUT', this.$kuzzle).then(() => {
        this.$router.push('/login');
      });
    },
    goBack() {
      const { name, params } = this.$route;
      if (name === 'maintenance-history') {
        this.$router.push({ name: 'asset', params });
      } else if (name === 'asset') {
        this.$router.push({ name: 'home' });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  background-color: $byes-green;
}

.navbar-brand-text {
  color: $byes-black;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 42px;
  text-align: center;
}

.navbar-toggler {
  border-color: $byes-green !important;
}

.header-item-full {
  flex: auto;
}

.header-item {
  display: flex;
  margin-right: 16px;
  align-self: stretch;
  align-items: center;
  flex-wrap: nowrap;
}

.break {
  flex-basis: 100%;
  height: 0;
}

@media (max-width: 767.98px) {
  .navbar-text-color {
    margin-left: 0;
  }

  .navbar {
    padding-bottom: 1rem;
  }
}
</style>
